import { Component, signal, computed, inject, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AttributionService } from '../services/attribution.service';

interface PriceRow {
  portas: number;
  tagsMin: number;
  tagsMax: number;
  valorMin: number;
  valorMax: number;
}

const PRICE_TABLE: PriceRow[] = [
  { portas: 1, tagsMin: 5, tagsMax: 60, valorMin: 1850, valorMax: 2950 },
  { portas: 1, tagsMin: 61, tagsMax: 100, valorMin: 2950, valorMax: 4600 },
  { portas: 1, tagsMin: 101, tagsMax: 200, valorMin: 4600, valorMax: 7600 },
  { portas: 1, tagsMin: 201, tagsMax: 500, valorMin: 7600, valorMax: 17700 },
  { portas: 1, tagsMin: 501, tagsMax: 1000, valorMin: 17700, valorMax: 35000 },
  { portas: 2, tagsMin: 5, tagsMax: 60, valorMin: 1850, valorMax: 2950 },
  { portas: 2, tagsMin: 61, tagsMax: 100, valorMin: 2950, valorMax: 4600 },
  { portas: 2, tagsMin: 101, tagsMax: 200, valorMin: 4600, valorMax: 7800 },
  { portas: 2, tagsMin: 201, tagsMax: 500, valorMin: 7800, valorMax: 18000 },
  { portas: 2, tagsMin: 501, tagsMax: 1000, valorMin: 18000, valorMax: 36000 },
  { portas: 3, tagsMin: 5, tagsMax: 60, valorMin: 1850, valorMax: 2950 },
  { portas: 3, tagsMin: 61, tagsMax: 100, valorMin: 2950, valorMax: 4600 },
  { portas: 3, tagsMin: 101, tagsMax: 200, valorMin: 4600, valorMax: 7800 },
  { portas: 3, tagsMin: 201, tagsMax: 500, valorMin: 7800, valorMax: 18600 },
  { portas: 3, tagsMin: 501, tagsMax: 1000, valorMin: 18600, valorMax: 36600 },
  { portas: 4, tagsMin: 5, tagsMax: 60, valorMin: 1850, valorMax: 3100 },
  { portas: 4, tagsMin: 61, tagsMax: 100, valorMin: 3100, valorMax: 4600 },
  { portas: 4, tagsMin: 101, tagsMax: 200, valorMin: 4600, valorMax: 7800 },
  { portas: 4, tagsMin: 201, tagsMax: 500, valorMin: 7800, valorMax: 18600 },
  { portas: 4, tagsMin: 501, tagsMax: 1000, valorMin: 18600, valorMax: 36600 },
  { portas: 5, tagsMin: 5, tagsMax: 60, valorMin: 1850, valorMax: 3100 },
  { portas: 5, tagsMin: 61, tagsMax: 100, valorMin: 3100, valorMax: 4600 },
  { portas: 5, tagsMin: 101, tagsMax: 200, valorMin: 4600, valorMax: 7800 },
  { portas: 5, tagsMin: 201, tagsMax: 500, valorMin: 7800, valorMax: 18600 },
  { portas: 5, tagsMin: 501, tagsMax: 1000, valorMin: 18600, valorMax: 36600 },
  { portas: 6, tagsMin: 5, tagsMax: 60, valorMin: 1850, valorMax: 3400 },
  { portas: 6, tagsMin: 61, tagsMax: 100, valorMin: 3100, valorMax: 4800 },
  { portas: 6, tagsMin: 101, tagsMax: 200, valorMin: 4800, valorMax: 7950 },
  { portas: 6, tagsMin: 201, tagsMax: 500, valorMin: 7950, valorMax: 18800 },
  { portas: 6, tagsMin: 501, tagsMax: 1000, valorMin: 18800, valorMax: 36850 },
  { portas: 7, tagsMin: 5, tagsMax: 60, valorMin: 1850, valorMax: 3600 },
  { portas: 7, tagsMin: 61, tagsMax: 100, valorMin: 3100, valorMax: 4950 },
  { portas: 7, tagsMin: 101, tagsMax: 200, valorMin: 4950, valorMax: 8150 },
  { portas: 7, tagsMin: 201, tagsMax: 500, valorMin: 8150, valorMax: 18800 },
  { portas: 7, tagsMin: 501, tagsMax: 1000, valorMin: 18800, valorMax: 36850 },
  { portas: 8, tagsMin: 5, tagsMax: 60, valorMin: 1850, valorMax: 3800 },
  { portas: 8, tagsMin: 61, tagsMax: 100, valorMin: 3800, valorMax: 5100 },
  { portas: 8, tagsMin: 101, tagsMax: 200, valorMin: 5100, valorMax: 8250 },
  { portas: 8, tagsMin: 201, tagsMax: 500, valorMin: 8250, valorMax: 18800 },
  { portas: 8, tagsMin: 501, tagsMax: 1000, valorMin: 18800, valorMax: 36850 },
  { portas: 9, tagsMin: 5, tagsMax: 60, valorMin: 2100, valorMax: 3950 },
  { portas: 9, tagsMin: 61, tagsMax: 100, valorMin: 3950, valorMax: 5300 },
  { portas: 9, tagsMin: 101, tagsMax: 200, valorMin: 5300, valorMax: 8800 },
  { portas: 9, tagsMin: 201, tagsMax: 500, valorMin: 8800, valorMax: 19400 },
  { portas: 9, tagsMin: 501, tagsMax: 1000, valorMin: 19400, valorMax: 37200 },
  { portas: 10, tagsMin: 5, tagsMax: 60, valorMin: 2100, valorMax: 4100 },
  { portas: 10, tagsMin: 61, tagsMax: 100, valorMin: 4100, valorMax: 5500 },
  { portas: 10, tagsMin: 101, tagsMax: 200, valorMin: 5500, valorMax: 8950 },
  { portas: 10, tagsMin: 201, tagsMax: 500, valorMin: 8950, valorMax: 19400 },
  { portas: 10, tagsMin: 501, tagsMax: 1000, valorMin: 19400, valorMax: 37200 },
  { portas: 11, tagsMin: 5, tagsMax: 60, valorMin: 2400, valorMax: 4300 },
  { portas: 11, tagsMin: 61, tagsMax: 100, valorMin: 4300, valorMax: 5700 },
  { portas: 11, tagsMin: 101, tagsMax: 200, valorMin: 5700, valorMax: 9200 },
  { portas: 11, tagsMin: 201, tagsMax: 500, valorMin: 9200, valorMax: 19600 },
  { portas: 11, tagsMin: 501, tagsMax: 1000, valorMin: 19600, valorMax: 37400 },
  { portas: 12, tagsMin: 5, tagsMax: 60, valorMin: 2600, valorMax: 4500 },
  { portas: 12, tagsMin: 61, tagsMax: 100, valorMin: 4500, valorMax: 5900 },
  { portas: 12, tagsMin: 101, tagsMax: 200, valorMin: 5900, valorMax: 9400 },
  { portas: 12, tagsMin: 201, tagsMax: 500, valorMin: 9400, valorMax: 19800 },
  { portas: 12, tagsMin: 501, tagsMax: 1000, valorMin: 19800, valorMax: 37600 },
  { portas: 13, tagsMin: 5, tagsMax: 60, valorMin: 2800, valorMax: 4700 },
  { portas: 13, tagsMin: 61, tagsMax: 100, valorMin: 4700, valorMax: 6100 },
  { portas: 13, tagsMin: 101, tagsMax: 200, valorMin: 6100, valorMax: 9600 },
  { portas: 13, tagsMin: 201, tagsMax: 500, valorMin: 9600, valorMax: 19950 },
  { portas: 13, tagsMin: 501, tagsMax: 1000, valorMin: 19950, valorMax: 37800 },
  { portas: 14, tagsMin: 5, tagsMax: 60, valorMin: 2950, valorMax: 4950 },
  { portas: 14, tagsMin: 61, tagsMax: 100, valorMin: 4950, valorMax: 6300 },
  { portas: 14, tagsMin: 101, tagsMax: 200, valorMin: 6300, valorMax: 9800 },
  { portas: 14, tagsMin: 201, tagsMax: 500, valorMin: 9800, valorMax: 20100 },
  { portas: 14, tagsMin: 501, tagsMax: 1000, valorMin: 20100, valorMax: 38200 },
  { portas: 15, tagsMin: 5, tagsMax: 60, valorMin: 3150, valorMax: 5150 },
  { portas: 15, tagsMin: 61, tagsMax: 100, valorMin: 5150, valorMax: 6500 },
  { portas: 15, tagsMin: 101, tagsMax: 200, valorMin: 6500, valorMax: 9950 },
  { portas: 15, tagsMin: 201, tagsMax: 500, valorMin: 9950, valorMax: 20300 },
  { portas: 15, tagsMin: 501, tagsMax: 1000, valorMin: 20300, valorMax: 38400 },
  { portas: 16, tagsMin: 5, tagsMax: 60, valorMin: 3300, valorMax: 5300 },
  { portas: 16, tagsMin: 61, tagsMax: 100, valorMin: 5300, valorMax: 6700 },
  { portas: 16, tagsMin: 101, tagsMax: 200, valorMin: 6700, valorMax: 10100 },
  { portas: 16, tagsMin: 201, tagsMax: 500, valorMin: 10100, valorMax: 20500 },
  { portas: 16, tagsMin: 501, tagsMax: 1000, valorMin: 20500, valorMax: 38500 },
  { portas: 17, tagsMin: 5, tagsMax: 60, valorMin: 3600, valorMax: 5500 },
  { portas: 17, tagsMin: 61, tagsMax: 100, valorMin: 5500, valorMax: 6900 },
  { portas: 17, tagsMin: 101, tagsMax: 200, valorMin: 6900, valorMax: 10300 },
  { portas: 17, tagsMin: 201, tagsMax: 500, valorMin: 10300, valorMax: 20700 },
  { portas: 17, tagsMin: 501, tagsMax: 1000, valorMin: 20700, valorMax: 38600 },
  { portas: 18, tagsMin: 5, tagsMax: 60, valorMin: 3800, valorMax: 5700 },
  { portas: 18, tagsMin: 61, tagsMax: 100, valorMin: 5700, valorMax: 7100 },
  { portas: 18, tagsMin: 101, tagsMax: 200, valorMin: 7100, valorMax: 10500 },
  { portas: 18, tagsMin: 201, tagsMax: 500, valorMin: 10500, valorMax: 20900 },
  { portas: 18, tagsMin: 501, tagsMax: 1000, valorMin: 20900, valorMax: 38800 },
  { portas: 19, tagsMin: 5, tagsMax: 60, valorMin: 3950, valorMax: 5900 },
  { portas: 19, tagsMin: 61, tagsMax: 100, valorMin: 5900, valorMax: 7300 },
  { portas: 19, tagsMin: 101, tagsMax: 200, valorMin: 7300, valorMax: 10700 },
  { portas: 19, tagsMin: 201, tagsMax: 500, valorMin: 10700, valorMax: 21200 },
  { portas: 19, tagsMin: 501, tagsMax: 1000, valorMin: 21200, valorMax: 39000 },
  { portas: 20, tagsMin: 5, tagsMax: 60, valorMin: 4150, valorMax: 6150 },
  { portas: 20, tagsMin: 61, tagsMax: 100, valorMin: 6150, valorMax: 7500 },
  { portas: 20, tagsMin: 101, tagsMax: 200, valorMin: 7500, valorMax: 10900 },
  { portas: 20, tagsMin: 201, tagsMax: 500, valorMin: 10900, valorMax: 21400 },
  { portas: 20, tagsMin: 501, tagsMax: 1000, valorMin: 21400, valorMax: 39200 },
  { portas: 21, tagsMin: 5, tagsMax: 60, valorMin: 4300, valorMax: 6300 },
  { portas: 21, tagsMin: 61, tagsMax: 100, valorMin: 6300, valorMax: 7650 },
  { portas: 21, tagsMin: 101, tagsMax: 200, valorMin: 7650, valorMax: 11100 },
  { portas: 21, tagsMin: 201, tagsMax: 500, valorMin: 11100, valorMax: 21600 },
  { portas: 21, tagsMin: 501, tagsMax: 1000, valorMin: 21600, valorMax: 39400 },
  { portas: 22, tagsMin: 5, tagsMax: 60, valorMin: 4450, valorMax: 6500 },
  { portas: 22, tagsMin: 61, tagsMax: 100, valorMin: 6500, valorMax: 7850 },
  { portas: 22, tagsMin: 101, tagsMax: 200, valorMin: 7850, valorMax: 11300 },
  { portas: 22, tagsMin: 201, tagsMax: 500, valorMin: 11300, valorMax: 21800 },
  { portas: 22, tagsMin: 501, tagsMax: 1000, valorMin: 21800, valorMax: 39700 },
  { portas: 23, tagsMin: 5, tagsMax: 60, valorMin: 4650, valorMax: 6700 },
  { portas: 23, tagsMin: 61, tagsMax: 100, valorMin: 6700, valorMax: 7950 },
  { portas: 23, tagsMin: 101, tagsMax: 200, valorMin: 7950, valorMax: 11500 },
  { portas: 23, tagsMin: 201, tagsMax: 500, valorMin: 11500, valorMax: 21950 },
  { portas: 23, tagsMin: 501, tagsMax: 1000, valorMin: 21950, valorMax: 39800 },
  { portas: 24, tagsMin: 5, tagsMax: 60, valorMin: 4850, valorMax: 6850 },
  { portas: 24, tagsMin: 61, tagsMax: 100, valorMin: 6850, valorMax: 9100 },
  { portas: 24, tagsMin: 101, tagsMax: 200, valorMin: 9100, valorMax: 11700 },
  { portas: 24, tagsMin: 201, tagsMax: 500, valorMin: 11700, valorMax: 22100 },
  { portas: 24, tagsMin: 501, tagsMax: 1000, valorMin: 22100, valorMax: 39900 },
  { portas: 25, tagsMin: 5, tagsMax: 60, valorMin: 5100, valorMax: 7000 },
  { portas: 25, tagsMin: 61, tagsMax: 100, valorMin: 7000, valorMax: 9300 },
  { portas: 25, tagsMin: 101, tagsMax: 200, valorMin: 9300, valorMax: 11900 },
  { portas: 25, tagsMin: 201, tagsMax: 500, valorMin: 11900, valorMax: 22300 },
  { portas: 25, tagsMin: 501, tagsMax: 1000, valorMin: 22300, valorMax: 40200 },
  { portas: 26, tagsMin: 5, tagsMax: 60, valorMin: 5300, valorMax: 7000 },
  { portas: 26, tagsMin: 61, tagsMax: 100, valorMin: 7200, valorMax: 9300 },
  { portas: 26, tagsMin: 101, tagsMax: 200, valorMin: 9500, valorMax: 11900 },
  { portas: 26, tagsMin: 201, tagsMax: 500, valorMin: 12100, valorMax: 22300 },
  { portas: 26, tagsMin: 501, tagsMax: 1000, valorMin: 22500, valorMax: 40400 },
  { portas: 27, tagsMin: 5, tagsMax: 60, valorMin: 5500, valorMax: 7400 },
  { portas: 27, tagsMin: 61, tagsMax: 100, valorMin: 7400, valorMax: 9700 },
  { portas: 27, tagsMin: 101, tagsMax: 200, valorMin: 9700, valorMax: 12300 },
  { portas: 27, tagsMin: 201, tagsMax: 500, valorMin: 12300, valorMax: 22700 },
  { portas: 27, tagsMin: 501, tagsMax: 1000, valorMin: 22700, valorMax: 40600 },
  { portas: 28, tagsMin: 5, tagsMax: 60, valorMin: 5700, valorMax: 7600 },
  { portas: 28, tagsMin: 61, tagsMax: 100, valorMin: 7600, valorMax: 9900 },
  { portas: 28, tagsMin: 101, tagsMax: 200, valorMin: 9900, valorMax: 12500 },
  { portas: 28, tagsMin: 201, tagsMax: 500, valorMin: 12500, valorMax: 22900 },
  { portas: 28, tagsMin: 501, tagsMax: 1000, valorMin: 22900, valorMax: 40800 },
  { portas: 29, tagsMin: 5, tagsMax: 60, valorMin: 5900, valorMax: 7800 },
  { portas: 29, tagsMin: 61, tagsMax: 100, valorMin: 7800, valorMax: 10100 },
  { portas: 29, tagsMin: 101, tagsMax: 200, valorMin: 10100, valorMax: 12700 },
  { portas: 29, tagsMin: 201, tagsMax: 500, valorMin: 12700, valorMax: 23000 },
  { portas: 29, tagsMin: 501, tagsMax: 1000, valorMin: 23000, valorMax: 40900 },
  { portas: 30, tagsMin: 5, tagsMax: 60, valorMin: 6100, valorMax: 7950 },
  { portas: 30, tagsMin: 61, tagsMax: 100, valorMin: 7950, valorMax: 10300 },
  { portas: 30, tagsMin: 101, tagsMax: 200, valorMin: 10300, valorMax: 12900 },
  { portas: 30, tagsMin: 201, tagsMax: 500, valorMin: 12900, valorMax: 23200 },
  { portas: 30, tagsMin: 501, tagsMax: 1000, valorMin: 23200, valorMax: 41200 },
  { portas: 31, tagsMin: 5, tagsMax: 60, valorMin: 6300, valorMax: 8000 },
  { portas: 31, tagsMin: 61, tagsMax: 100, valorMin: 8000, valorMax: 10500 },
  { portas: 31, tagsMin: 101, tagsMax: 200, valorMin: 10500, valorMax: 13100 },
  { portas: 31, tagsMin: 201, tagsMax: 500, valorMin: 13100, valorMax: 23400 },
  { portas: 31, tagsMin: 501, tagsMax: 1000, valorMin: 23400, valorMax: 41400 },
  { portas: 32, tagsMin: 5, tagsMax: 60, valorMin: 6500, valorMax: 8200 },
  { portas: 32, tagsMin: 61, tagsMax: 100, valorMin: 8200, valorMax: 10700 },
  { portas: 32, tagsMin: 101, tagsMax: 200, valorMin: 10700, valorMax: 13300 },
  { portas: 32, tagsMin: 201, tagsMax: 500, valorMin: 13300, valorMax: 23600 },
  { portas: 32, tagsMin: 501, tagsMax: 1000, valorMin: 23600, valorMax: 41500 },
  { portas: 33, tagsMin: 5, tagsMax: 60, valorMin: 6700, valorMax: 8400 },
  { portas: 33, tagsMin: 61, tagsMax: 100, valorMin: 8400, valorMax: 10900 },
  { portas: 33, tagsMin: 101, tagsMax: 200, valorMin: 10900, valorMax: 13600 },
  { portas: 33, tagsMin: 201, tagsMax: 500, valorMin: 13600, valorMax: 23800 },
  { portas: 33, tagsMin: 501, tagsMax: 1000, valorMin: 23800, valorMax: 41700 },
  { portas: 34, tagsMin: 5, tagsMax: 60, valorMin: 6700, valorMax: 8500 },
  { portas: 34, tagsMin: 61, tagsMax: 100, valorMin: 8500, valorMax: 11000 },
  { portas: 34, tagsMin: 101, tagsMax: 200, valorMin: 11000, valorMax: 13800 },
  { portas: 34, tagsMin: 201, tagsMax: 500, valorMin: 13800, valorMax: 23900 },
  { portas: 34, tagsMin: 501, tagsMax: 1000, valorMin: 23900, valorMax: 41900 },
  { portas: 35, tagsMin: 5, tagsMax: 60, valorMin: 6900, valorMax: 8700 },
  { portas: 35, tagsMin: 61, tagsMax: 100, valorMin: 8700, valorMax: 10200 },
  { portas: 35, tagsMin: 101, tagsMax: 200, valorMin: 10200, valorMax: 13950 },
  { portas: 35, tagsMin: 201, tagsMax: 500, valorMin: 13950, valorMax: 24100 },
  { portas: 35, tagsMin: 501, tagsMax: 1000, valorMin: 24100, valorMax: 42000 },
  { portas: 36, tagsMin: 5, tagsMax: 60, valorMin: 7100, valorMax: 8900 },
  { portas: 36, tagsMin: 61, tagsMax: 100, valorMin: 8900, valorMax: 11400 },
  { portas: 36, tagsMin: 101, tagsMax: 200, valorMin: 11400, valorMax: 14000 },
  { portas: 36, tagsMin: 201, tagsMax: 500, valorMin: 14000, valorMax: 24300 },
  { portas: 36, tagsMin: 501, tagsMax: 1000, valorMin: 24300, valorMax: 42200 },
  { portas: 37, tagsMin: 5, tagsMax: 60, valorMin: 7200, valorMax: 9000 },
  { portas: 37, tagsMin: 61, tagsMax: 100, valorMin: 9000, valorMax: 10600 },
  { portas: 37, tagsMin: 101, tagsMax: 200, valorMin: 10600, valorMax: 14200 },
  { portas: 37, tagsMin: 201, tagsMax: 500, valorMin: 14200, valorMax: 24500 },
  { portas: 37, tagsMin: 501, tagsMax: 1000, valorMin: 24500, valorMax: 42400 },
  { portas: 38, tagsMin: 5, tagsMax: 60, valorMin: 7400, valorMax: 9200 },
  { portas: 38, tagsMin: 61, tagsMax: 100, valorMin: 9200, valorMax: 10800 },
  { portas: 38, tagsMin: 101, tagsMax: 200, valorMin: 10800, valorMax: 14400 },
  { portas: 38, tagsMin: 201, tagsMax: 500, valorMin: 14400, valorMax: 25000 },
  { portas: 38, tagsMin: 501, tagsMax: 1000, valorMin: 25000, valorMax: 42600 },
  { portas: 39, tagsMin: 5, tagsMax: 60, valorMin: 7600, valorMax: 9600 },
  { portas: 39, tagsMin: 61, tagsMax: 100, valorMin: 9600, valorMax: 11000 },
  { portas: 39, tagsMin: 101, tagsMax: 200, valorMin: 11000, valorMax: 14600 },
  { portas: 39, tagsMin: 201, tagsMax: 500, valorMin: 14600, valorMax: 25200 },
  { portas: 39, tagsMin: 501, tagsMax: 1000, valorMin: 25200, valorMax: 42700 },
  { portas: 40, tagsMin: 5, tagsMax: 60, valorMin: 7800, valorMax: 9800 },
  { portas: 40, tagsMin: 61, tagsMax: 100, valorMin: 9800, valorMax: 11200 },
  { portas: 40, tagsMin: 101, tagsMax: 200, valorMin: 11200, valorMax: 14800 },
  { portas: 40, tagsMin: 201, tagsMax: 500, valorMin: 14800, valorMax: 25300 },
  { portas: 40, tagsMin: 501, tagsMax: 1000, valorMin: 25300, valorMax: 42900 },
];

@Component({
  selector: 'app-simulator-v2',
  standalone: true,
  imports: [FormsModule],
  template: `
    <section class="simulator-section" id="simulador" [class.compacto]="compacto">
      <div class="simulator-container">

        <!-- HEADER -->
        <div class="simulator-header">
          <span class="simulator-badge">SIMULADOR DE INVESTIMENTO</span>
          <h2>Descubra quanto custa proteger<br><span class="highlight">sua operação hoje.</span></h2>
          <p>Preencha os campos abaixo e veja uma estimativa personalizada em segundos.</p>
        </div>

        <!-- PROGRESS BAR -->
        <div class="progress-bar">
          <div class="progress-fill" [style.width]="progressWidth()"></div>
        </div>
        <div class="step-labels">
          <span [class.active]="currentStep() >= 1">Seus dados</span>
          <span [class.active]="currentStep() >= 2">Sua operação</span>
        </div>

        <!-- STEP 1 — Dados do lead -->
        @if (currentStep() === 1) {
        <div class="step-content">
          <h3>Primeiro, nos conte um pouco sobre você.</h3>
          <div class="form-group">
            <label>Nome completo *</label>
            <input type="text" [(ngModel)]="nome" placeholder="Ex: João Silva" />
          </div>
          <div class="form-group">
            <label>WhatsApp *</label>
            <input type="tel" [(ngModel)]="whatsapp" placeholder="(11) 99999-9999" />
          </div>
          <div class="form-group">
            <label>Empresa *</label>
            <input type="text" [(ngModel)]="empresa" placeholder="Ex: Frigorífico Central" />
          </div>
          <div class="form-group">
            <label>Email corporativo *</label>
            <input type="email" [(ngModel)]="email" placeholder="Ex: joao@empresa.com.br" />
          </div>
          <button class="btn-next" (click)="nextStep()" [disabled]="!step1Valid()">
            Próximo passo →
          </button>
        </div>
        }

        <!-- STEP 2 — Dados da operação -->
        @if (currentStep() === 2) {
        <div class="step-content">
          <h3>Agora nos fale sobre sua operação.</h3>

          <div class="form-group">
            <label>Quantas portas de câmara fria você tem?</label>
            <input type="number" [(ngModel)]="portas" min="1" max="40" placeholder="Ex: 3" />
          </div>

          <div class="form-group">
            <label>Quantos colaboradores trabalham nas câmaras frias?</label>
            <input type="number" [(ngModel)]="colaboradores" min="5" max="1000" placeholder="Ex: 45" />
          </div>

          <div class="step-buttons">
            <button class="btn-back" (click)="prevStep()">← Voltar</button>
            <button class="btn-next" (click)="nextStep()" [disabled]="isSubmitting">{{ isSubmitting ? 'Enviando...' : 'Ver minha simulação →' }}</button>
          </div>
        </div>
        }


      </div>
    </section>
  `,
  styles: [`
    .simulator-section {
      background: #0a0a0a;
      padding: 80px 20px;
    }

    .simulator-section.compacto {
      background: transparent;
      padding: 0;
    }

    .simulator-section.compacto .simulator-header { display: none; }

    .simulator-section.compacto .step-content { padding: 20px; }

    .simulator-section.compacto .progress-bar { background: rgba(255,255,255,0.1); }

    .simulator-section.compacto .step-labels span { color: rgba(255,255,255,0.5); }
    .simulator-section.compacto .step-labels span.active { color: #ffffff; }

    .simulator-section.compacto input,
    .simulator-section.compacto textarea,
    .simulator-section.compacto select {
      background: #2a2a2a;
      border: 1px solid rgba(255,255,255,0.2);
      color: #ffffff;
    }

    .simulator-section.compacto input::placeholder,
    .simulator-section.compacto textarea::placeholder {
      color: rgba(255,255,255,0.4);
    }

    .simulator-section.compacto label { color: rgba(255,255,255,0.85); }

    .simulator-container {
      max-width: 620px;
      margin: 0 auto;
    }

    .simulator-header {
      text-align: center;
      margin-bottom: 40px;
    }

    .simulator-badge {
      display: inline-block;
      background: rgba(255, 107, 0, 0.15);
      color: #ff6b00;
      border: 1px solid rgba(255, 107, 0, 0.3);
      border-radius: 20px;
      padding: 6px 16px;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 1px;
      margin-bottom: 16px;
    }

    .simulator-header h2 {
      font-size: 2rem;
      color: #ffffff;
      font-weight: 700;
      line-height: 1.3;
      margin-bottom: 12px;
    }

    .highlight { color: #ff6b00; }

    .simulator-header p {
      color: #888;
      font-size: 1rem;
    }

    .progress-bar {
      background: #1a1a1a;
      border-radius: 4px;
      height: 4px;
      margin-bottom: 8px;
      overflow: hidden;
    }

    .progress-fill {
      background: #ff6b00;
      height: 100%;
      transition: width 0.4s ease;
      border-radius: 4px;
    }

    .step-labels {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;
    }

    .step-labels span {
      font-size: 12px;
      color: #444;
      transition: color 0.3s;
    }

    .step-labels span.active { color: #ff6b00; font-weight: 600; }

    .step-content {
      background: #111;
      border: 1px solid #222;
      border-radius: 16px;
      padding: 40px;
    }

    .step-content h3 {
      color: #fff;
      font-size: 1.3rem;
      font-weight: 600;
      margin-bottom: 28px;
    }

    .form-group {
      margin-bottom: 24px;
    }

    .form-group label {
      display: block;
      color: #ccc;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .form-group input[type="text"],
    .form-group input[type="tel"],
    .form-group input[type="number"],
    .form-group input[type="email"] {
      width: 100%;
      background: #1a1a1a;
      border: 1px solid #333;
      border-radius: 8px;
      padding: 14px 16px;
      color: #fff;
      font-size: 15px;
      outline: none;
      transition: border-color 0.2s;
      box-sizing: border-box;
    }

    .form-group input:focus { border-color: #ff6b00; }


    .btn-next {
      width: 100%;
      background: #ff6b00;
      color: #fff;
      border: none;
      border-radius: 10px;
      padding: 16px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      margin-top: 8px;
      transition: background 0.2s, transform 0.1s;
    }

    .btn-next:hover { background: #e55f00; }
    .btn-next:active { transform: scale(0.98); }
    .btn-next:disabled { background: #333; color: #666; cursor: not-allowed; }

    .step-buttons {
      display: flex;
      gap: 12px;
      margin-top: 8px;
    }

    .btn-back {
      background: transparent;
      border: 1px solid #333;
      color: #888;
      border-radius: 10px;
      padding: 16px 20px;
      font-size: 15px;
      cursor: pointer;
      transition: border-color 0.2s;
    }

    .btn-back:hover { border-color: #555; color: #ccc; }

    /* RESULT */
    .result-step { text-align: center; }

    .result-icon { font-size: 2.5rem; margin-bottom: 12px; }

    .result-step h3 {
      font-size: 1.4rem;
      margin-bottom: 4px;
    }

    .result-subtitle {
      color: #666;
      font-size: 14px;
      margin-bottom: 28px;
    }

    .result-card {
      background: linear-gradient(135deg, #1a1a1a, #111);
      border: 1px solid #ff6b00;
      border-radius: 16px;
      padding: 28px;
      margin-bottom: 24px;
    }

    .result-label {
      color: #888;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 12px;
    }

    .result-range {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      margin-bottom: 10px;
    }

    .result-min, .result-max {
      font-size: 2rem;
      font-weight: 800;
      color: #ff6b00;
    }

    .result-separator {
      color: #555;
      font-size: 14px;
    }

    .result-detail {
      color: #555;
      font-size: 12px;
    }

    .result-benefits {
      text-align: left;
      margin-bottom: 28px;
    }

    .benefit-item {
      color: #ccc;
      font-size: 14px;
      padding: 8px 0;
      border-bottom: 1px solid #1a1a1a;
    }

    .btn-whatsapp {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      background: #25D366;
      color: #fff;
      text-decoration: none;
      border: none;
      width: 100%;
      border-radius: 10px;
      padding: 16px;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 16px;
      cursor: pointer;
      transition: background 0.2s;
    }

    .btn-whatsapp:hover { background: #1da851; }

    .result-disclaimer {
      color: #555;
      font-size: 12px;
      margin-bottom: 20px;
    }

    .btn-restart {
      background: transparent;
      border: none;
      color: #555;
      font-size: 13px;
      cursor: pointer;
      text-decoration: underline;
    }

    .btn-restart:hover { color: #888; }

    @media (max-width: 640px) {
      .step-content { padding: 24px 20px; }
      .simulator-header h2 { font-size: 1.5rem; }
      .result-min, .result-max { font-size: 1.5rem; }
      .slider-value { min-width: 90px; font-size: 12px; }
    }
  `]
})
export class SimulatorV2Component {
  router = inject(Router);
  private attributionService = inject(AttributionService);
  @Input() compacto = false;
  @Output() concluido = new EventEmitter<void>();
  currentStep = signal(1);
  isSubmitting = false;
  nome = '';
  whatsapp = '';
  empresa = '';
  email = '';
  portas = 1;
  colaboradores = 5;

  progressWidth = computed(() => {
    return this.currentStep() === 1 ? '50%' : '100%';
  });

  step1Valid() {
    return this.nome.trim().length > 2 &&
           this.whatsapp.trim().length > 8 &&
           this.empresa.trim().length > 1 &&
           this.email.trim().includes('@');
  }

  nextStep() {
    if (this.currentStep() === 1) {
      this.currentStep.set(2);
    } else if (this.currentStep() === 2) {
      this.goToObrigado();
    }
  }

  prevStep() {
    if (this.currentStep() > 1) this.currentStep.update(s => s - 1);
  }

  onSliderChange() {}

  private lookupPrice(portas: number, colaboradores: number): { min: number, max: number } {
    const p = Math.min(portas, 40);
    const c = Math.min(Math.max(colaboradores, 5), 1000);
    const row = PRICE_TABLE.find(r => r.portas === p && c >= r.tagsMin && c <= r.tagsMax);
    if (row) return { min: row.valorMin, max: row.valorMax };
    const fallback = PRICE_TABLE.filter(r => r.portas === p).pop();
    return { min: fallback?.valorMin ?? 1850, max: fallback?.valorMax ?? 35000 };
  }

  goToObrigado() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    sessionStorage.setItem('beetrack_simulador_concluido', 'true');

    const result = this.lookupPrice(this.portas, this.colaboradores);
    const qp = {
      nome: this.nome,
      empresa: this.empresa,
      portas: this.portas,
      colaboradores: this.colaboradores,
      valorMin: result.min,
      valorMax: result.max
    };

    const attribution = this.attributionService.getAttribution();

    const sheetsPayload = {
      nome: this.nome,
      whatsapp: this.whatsapp,
      empresa: this.empresa,
      email: this.email,
      portas: this.portas,
      colaboradores: this.colaboradores,
      valorMin: result.min,
      valorMax: result.max,
      ...attribution
    };

    const zapiMessage =
      `🔔 Novo lead simulou na beetrack!\n\n` +
      `👤 Nome: ${this.nome}\n` +
      `📱 WhatsApp: ${this.whatsapp}\n` +
      `🏢 Empresa: ${this.empresa}\n` +
      `📧 Email: ${this.email}\n` +
      `🚪 Portas: ${this.portas}\n` +
      `👷 Colaboradores: ${this.colaboradores}\n` +
      `💰 Estimativa: R$${result.min} a R$${result.max}/mês\n\n` +
      `📲 Entre em contato agora!`;

    console.log('[beetrack] Enviando para Google Sheets (GET):', sheetsPayload);
    const sheetsQs = new URLSearchParams(
      Object.fromEntries(Object.entries(sheetsPayload).map(([k, v]) => [k, String(v)]))
    );
    const sheetsCall = fetch(
      'https://script.google.com/macros/s/AKfycbyTpi3oJwO4IRrQsgmIn-X6ttglrm0BO1z3eY_rqIN8X2lyzkZsbPebbfekzV6G2pXzxA/exec?' + sheetsQs.toString(),
      { method: 'GET', mode: 'no-cors' }
    ).then(() => {
      console.log('[beetrack] Google Sheets: requisição enviada (no-cors, sem leitura de resposta)');
    }).catch(err => console.error('[beetrack] Google Sheets erro:', err));

    const zapiBody = { phone: '120363411172685496-group', message: zapiMessage };
    console.log('[beetrack] Enviando para Z-API:', zapiBody);
    const zapiCall = fetch(
      'https://api.z-api.io/instances/3ECE3973688CB2D7C0AEDAD6DC7CFA85/token/8E52C9D13FA51E01BF764651/send-text',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Client-Token': 'F0401d12a05d94085ad4f4f14c353f1a0S'
        },
        body: JSON.stringify(zapiBody)
      }
    ).then(res => {
      console.log('[beetrack] Z-API status:', res.status, res.statusText);
      return res.text().then(body => console.log('[beetrack] Z-API response:', body));
    }).catch(err => console.error('[beetrack] Z-API erro:', err));

    Promise.all([sheetsCall, zapiCall])
      .catch(() => {})
      .finally(() => {
        this.concluido.emit();
        this.router.navigate(['/v2/obrigado'], { queryParams: qp });
      });
  }
}
